import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { InviteService } from '@se-po/shared-data-access-services'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'
import { UserServiceResources as us } from 'se-resource-types'

@Component({
  selector: 'se-po-minor-account-invite',
  templateUrl: './minor-account-invite.component.html',
  styleUrls: ['./minor-account-invite.component.scss'],
})
export class MinorAccountInviteComponent implements OnInit {

  public form: FormGroup
  public inviteId: string
  public invite: us.Invitation
  public ready = false
  public submitting = false

  constructor(
    private fb: FormBuilder,
    private inviteService: InviteService,
    private route: ActivatedRoute,
    private router: Router,
    private setupService: SetupBarService,
  ) {}

  public ngOnInit(): void {
    this.initForm()
    this.inviteId = this.route.snapshot.params.id
    this.setupService.percentComplete = 50
    this.inviteService.find(this.inviteId).subscribe({
      next: invite => {
        if (invite.status === 'pending') {
          this.invite = invite
          this.ready = true
        }
        else if (invite.status === 'sent') {
          this.router.navigate(['/minor-account', 'repeat', this.inviteId])
        }
        else this.notFound()
      },
      error: () => this.notFound()
    })
  }

  public validateAndSubmit(): void {
    if (!this.form.valid) return

    this.submitting = true
    this.inviteService.update(this.inviteId, {
      email: this.form.value.emailAddress,
    }).subscribe({
      next: res => {
        console.log('next', res)
        this.router.navigate(['/minor-account', 'invite', 'sent'])
      },
      error: err => {
        console.error('error', err)
        this.submitting = false
      }
    })
  }

  private initForm(): void {
    this.form = this.fb.group({
      emailAddress: ['', [Validators.required, Validators.email]],
    })
  }

  private notFound(): void {
    this.router.navigate(['/minor-account', 'not-found'])
  }
}
